export const CAMPOS_FORMULARIO = {
  RAZON_SOCIAL: 'razonSocial',
  NOMBRE: 'nombre',
  APELLIDOS: 'apellidos',
  EMAIL: 'email',
  ID_FISCAL: 'idFiscal',
  DIRECCION: 'direccion',
  CODIGO_POSTAL: 'codigoPostal',
  POBLACION: 'poblacion',
  PROVINCIA: 'provincia',
  LUGAR_NACIMIENTO: 'lugarNacimiento',
  DNI: 'dni',
  PASAPORTE: 'pasaporte',
  ALERGIAS: 'alergias',
  ALTURA: 'altura',
  PESO: 'peso',
  TALLA_PIE: 'tallaPie',
};
